import React, { useState } from 'react';
import './Industries.css';

import { industries } from '../../../constants';
import { Heading } from '../../../components';



const Industries = () => {

  // State to track the currently active industry tab
  const [activeTab, setActiveTab] = useState('healthcare');

  // Find the currently active industry based on activeTab state
  const activeIndustry = industries.find((industry) => industry.id === activeTab);

  return (
    <section className="industries linear-bg">
      
      {/* Section Heading */}
      <Heading title={"Industries We Serve"} subTitle={"What We Offer"} linear />

      <div className="box-container tab-info">

        {/* Industries Buttons */}
        <div className="tab-buttons">
          {industries.map((industry) => (
            <button
              key={industry.id}
              type="button"
              className={`button ${activeTab === industry.id ? 'active' : ''}`}
              onClick={() => setActiveTab(industry.id)}
            >
              <i>{industry.icon}</i> {/* Industry Icon */}
              {industry.title} {/* Industry Title */}
            </button>
          ))}
        </div>

        {/* Industries Content */}
        <div className="tab-sections">

          {/* Display details of the currently active industry */}
          {activeIndustry && (
            <div className="tab-section active" id={activeIndustry.id}>

              {/* Industry heading */}
              <h3>{activeIndustry.heading}</h3>

              {/* Industry description */}
              {activeIndustry.description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}

              {/* List of industry features */}
              <ul className="industry-features">
                {activeIndustry.features.map((feature, index) => (
                  <li key={index}>
                    <i>{feature.icon}</i>
                    <span>{feature.text}</span>
                  </li>
                ))}
              </ul>

            </div>
          )}
        </div>

      </div>
    </section>
  );
};

export default Industries;